/* ============================================================
   Sandvig Pharma Sundhedstest
   Vanilla JS quiz — vælg behov → besvar spørgsmål → opdelt resultat.
   ============================================================ */

(function () {
    "use strict";

    // ---------- Tekst-strings (kan overrides fra Liquid section) ----------

    const DEFAULT_TEXTS = {
        // Velkomstskærm
        welcome_eyebrow: "Sandvig Pharma sundhedstest",
        welcome_heading: "Find de produkter, der passer til din krop",
        welcome_intro:
            "Besvar nogle få spørgsmål om dine behov, så får du anbefalinger " +
            "målrettet din krop - baseret på Sandvig Pharmas dokumenterede kosttilskud.",
        welcome_start_button: "Start sundhedstesten →",
        // Behovsvælger
        picker_heading: "Hvilke områder vil du gerne arbejde med?",
        picker_hint: "Vælg op til {max} behov, så får du et målrettet resultat.",
        picker_counter: "{count} af {max} valgt",
        picker_back_button: "← Tilbage",
        picker_continue_button: "Fortsæt til spørgsmål →",
        // Spørgsmålsflow
        q_back_to_picker: "← Skift valg af områder",
        q_prev_button: "← Forrige spørgsmål",
        q_next_button: "Næste →",
        q_last_button: "Se mit resultat →",
        // Resultatside
        result_eyebrow: "Din sundhedstest",
        result_heading: "Dine personlige anbefalinger",
        result_summary_single:
            "Baseret på dine svar har vi udvalgt produkter målrettet dit valgte behov. " +
            "Anbefalingerne er opdelt nedenfor, så du kan se hvad der hjælper med hvad.",
        result_summary_multi:
            "Baseret på dine svar har vi udvalgt produkter målrettet dine valgte behov. " +
            "Anbefalingerne er opdelt nedenfor, så du kan se hvad der hjælper med hvad.",
        result_restart_button: "Tag testen igen",
        result_all_products_link: "Se alle produkter →",
        // Produktgrupper
        product_group_package: "Sundhedspakke — alt-i-én",
        product_group_main_single: "Anbefalet hovedprodukt",
        product_group_main_multi: "Anbefalede hovedprodukter",
        product_group_secondary: "Relaterede produkter — målrettet ekstra støtte",
        product_group_basic: "Basisprodukter — sundt fundament",
        // Score-labels
        score_label_prefix: "Din score:",
        score_label_of: "af {max}",
        // Email-capture
        email_heading: "Få dit resultat tilsendt på mail",
        email_subtitle:
            "Send mig en kopi af mine anbefalinger, så jeg altid kan vende tilbage " +
            "til de aktuelle produkter og priser.",
        email_placeholder: "din@email.dk",
        email_submit_button: "Send mig det",
        email_submit_sending: "Sender…",
        email_success_heading: "Tak — du hører fra os!",
        email_success_message: "Dit resultat bliver sendt til {email}.",
        email_consent_notice:
            "Når du får dit resultat tilsendt, tilmelder du dig samtidigt vores " +
            "nyhedsbrev og bliver en del af SandvigCare fællesskabet — med " +
            "vidensdeling, faglig inspiration og VIP adgang til nyheder.",
    };

    const TEXTS = { ...DEFAULT_TEXTS };
    const textsEl = document.getElementById("sp-quiz-texts");
    if (textsEl) {
        try {
            const overrides = JSON.parse(textsEl.textContent);
            Object.keys(overrides).forEach((k) => {
                const v = overrides[k];
                if (v != null && String(v).trim() !== "") TEXTS[k] = v;
            });
        } catch (e) {
            console.warn("[Sandvig quiz] Kunne ikke parse tekst-overrides:", e);
        }
    }

    function t(key, replacements) {
        let s = TEXTS[key] ?? key;
        if (replacements) {
            Object.keys(replacements).forEach((k) => {
                s = s.replaceAll(`{${k}}`, replacements[k]);
            });
        }
        return s;
    }

    // ---------- Config & state ----------

    const MAX_SELECTIONS = 3;

    const ROOT = document.getElementById("sp-quiz-root");
    if (!ROOT) {
        console.error("[Sandvig quiz] Mangler #sp-quiz-root element");
        return;
    }

    // Indstillinger fra root attribut (kan ændres pr. side)
    const SHOP_URL = ROOT.dataset.shopUrl || "https://www.sandvigpharma.com";
    const KLAVIYO_LIST_ID = ROOT.dataset.klaviyoListId || ""; // sættes af kunden
    const KLAVIYO_COMPANY_ID = ROOT.dataset.klaviyoCompanyId || ""; // public key
    const FETCH_LIVE_PRODUCTS = ROOT.dataset.fetchLiveProducts === "true";
    const CONFIG_URL = ROOT.dataset.configUrl || "";

    // Hent config:
    // 1) Inline <script id="sp-quiz-config"> (standalone-demo)
    // 2) Async fetch fra data-config-url (Shopify-asset)
    let CONFIG = null;
    const inlineConfig = document.getElementById("sp-quiz-config");
    if (inlineConfig) {
        try {
            CONFIG = JSON.parse(inlineConfig.textContent);
        } catch (e) {
            console.error("[Sandvig quiz] Kunne ikke parse quiz-config:", e);
            return;
        }
    }

    async function loadConfig() {
        if (CONFIG) return CONFIG;
        if (!CONFIG_URL) {
            console.error("[Sandvig quiz] Ingen config fundet (hverken inline eller data-config-url)");
            return null;
        }
        try {
            const res = await fetch(CONFIG_URL, { credentials: "omit" });
            if (!res.ok) throw new Error(res.status);
            CONFIG = await res.json();
            return CONFIG;
        } catch (e) {
            console.error("[Sandvig quiz] Kunne ikke loade config fra", CONFIG_URL, e);
            return null;
        }
    }

    // Quiz-state
    const state = {
        step: "welcome", // welcome | picker | questions | result
        selectedCollections: [], // array af collection-id'er i valgt rækkefølge
        currentQuestionIdx: 0, // index ind i flattenedQuestions
        answers: {}, // { "collectionId:qId": answerValue }
        flattenedQuestions: [], // [{ collectionId, question, qNumber, totalForCollection }]
    };

    // ---------- Helpers ----------

    function getCollection(id) {
        return CONFIG.collections.find((c) => c.id === id);
    }
    function getProduct(handle) {
        return CONFIG.products[handle] || null;
    }
    function getAnswerOption(value) {
        return CONFIG.answerOptions.find((o) => o.value === value);
    }
    function getThresholdFor(score) {
        return CONFIG.scoringThresholds.find(
            (t) => score >= t.min && score <= t.max
        ) || CONFIG.scoringThresholds[CONFIG.scoringThresholds.length - 1];
    }
    function thresholdKey(threshold) {
        // Returnerer den nøgle der findes i collection.resultBodies
        // (matcher Excel-kolonnerne R/S/T/U for nu: 0-2 / 3-5 / 6-8 / 9-12)
        return `${threshold.min}-${threshold.max}`;
    }
    function escapeHtml(s) {
        const d = document.createElement("div");
        d.textContent = s == null ? "" : String(s);
        return d.innerHTML;
    }

    // Renderer bold-markup fra Excel: escaper først HTML, konverterer så
    // "**...**" markører til <strong>. Escaped tekst med & osv. bevares korrekt.
    function renderMarkdown(escapedText) {
        if (!escapedText) return "";
        // Backslash-escaped ** (fra rå ** i original tekst) beholdes som **
        return escapedText
            .replace(/\*\*([^*]+?)\*\*/g, "<strong>$1</strong>")
            .replace(/\\\*\\\*/g, "**");
    }
    // Bekvemmelighed: escape + render markdown i ét
    function html(text) {
        return renderMarkdown(escapeHtml(text));
    }

    // Bolder de første "brand"-bogstaver i et produktnavn efter Sandvigs mønster.
    // fx REFLOW → <strong>RE</strong>FLOW, BeautyCare → <strong>Beauty</strong>Care.
    function boldProductName(rawName) {
        const escaped = escapeHtml(rawName || "");
        const patterns = [
            // RE-prefix: REFLOW, REJOIN, REDEFINE, REFERTILE MALE osv.
            { re: /^(RE)([A-ZÆØÅ].*)$/i, replace: "<strong>$1</strong>$2" },
            // VITA-prefix: VITAC+, VITAB+
            { re: /^(VITA)([A-Z]\+?)$/i, replace: "<strong>$1</strong>$2" },
            // IRON: IRONCOMPLEX
            { re: /^(IRON)(COMPLEX)$/i, replace: "<strong>$1</strong>$2" },
            // *Care pattern: BeautyCare, MobilityCare, RLSCare, VitalCare 45+
            { re: /^(.+?)(Care)(\s?\d*\+?)$/i, replace: "<strong>$1</strong>$2$3" },
            // Standalone all-caps ord: MAGNESIUM → bold M
            { re: /^(M)(AGNESIUM)$/i, replace: "<strong>$1</strong>$2" },
        ];
        for (const p of patterns) {
            if (p.re.test(escaped)) return escaped.replace(p.re, p.replace);
        }
        return escaped;
    }
    function formatPrice(p) {
        if (!p) return "";
        const num = parseFloat(p);
        if (isNaN(num)) return p;
        return num.toLocaleString("da-DK", { minimumFractionDigits: 2 }) + " kr";
    }

    // Cache af alle pakke-handles på tværs af collections — bruges til at give
    // 30% abonnementsrabat på pakker, 20% på enkeltprodukter (matcher Sandvigs setup).
    let _packageHandles = null;
    function getPackageHandles() {
        if (_packageHandles) return _packageHandles;
        _packageHandles = new Set(
            CONFIG.collections.map((c) => c.package).filter(Boolean)
        );
        return _packageHandles;
    }

    // ---------- URL state encoding ----------
    // Format: ?r=1-22102100.7-12012012.22-00220020
    // Hver collection: "id-svar" hvor svar er en sekvens af 0/1/2/_ (én pr. spørgsmål)
    // 0=Nej, 1=Nogen gange, 2=Ja, _=Ikke besvaret
    const ANS_TO_CHAR = { yes: "2", sometimes: "1", no: "0" };
    const CHAR_TO_ANS = { 2: "yes", 1: "sometimes", 0: "no" };

    function encodeStateToUrl() {
        const parts = [];
        for (const cid of state.selectedCollections) {
            const c = getCollection(cid);
            if (!c) continue;
            const ansChars = c.questions.map((q) => {
                const a = state.answers[`${cid}:${q.id}`];
                return ANS_TO_CHAR[a] ?? "_";
            });
            parts.push(`${cid}-${ansChars.join("")}`);
        }
        return parts.join(".");
    }

    function decodeStateFromUrl(encoded) {
        if (!encoded) return null;
        try {
            const collectionIds = [];
            const answers = {};
            const parts = encoded.split(".");
            for (const part of parts) {
                const [idStr, ansStr] = part.split("-");
                const cid = parseInt(idStr, 10);
                if (!cid) continue;
                const c = getCollection(cid);
                if (!c) continue;
                collectionIds.push(cid);
                if (ansStr) {
                    c.questions.forEach((q, i) => {
                        const ch = ansStr[i];
                        if (CHAR_TO_ANS[ch]) {
                            answers[`${cid}:${q.id}`] = CHAR_TO_ANS[ch];
                        }
                    });
                }
            }
            return { collectionIds, answers };
        } catch (e) {
            console.warn("[Sandvig quiz] Kunne ikke parse URL-state:", e);
            return null;
        }
    }

    function updateUrlState() {
        if (typeof window === "undefined" || !window.history?.replaceState) return;
        try {
            const encoded = encodeStateToUrl();
            const url = new URL(window.location.href);
            if (encoded) url.searchParams.set("r", encoded);
            else url.searchParams.delete("r");
            window.history.replaceState({}, "", url.toString());
        } catch (_) { /* fail-soft */ }
    }

    function fullResultUrl() {
        // Bruges som link i Klaviyo-mailen
        if (typeof window === "undefined") return "";
        const url = new URL(window.location.href);
        const encoded = encodeStateToUrl();
        if (encoded) url.searchParams.set("r", encoded);
        return url.toString();
    }

    // ---------- UTM tagging ----------
    function withUtm(url, opts) {
        opts = opts || {};
        try {
            const u = new URL(url, SHOP_URL);
            u.searchParams.set("utm_source", "sundhedstest");
            u.searchParams.set("utm_medium", "quiz");
            if (opts.campaign) u.searchParams.set("utm_campaign", opts.campaign);
            if (opts.content) u.searchParams.set("utm_content", opts.content);
            if (opts.term) u.searchParams.set("utm_term", opts.term);
            return u.toString();
        } catch (_) {
            return url;
        }
    }

    // ---------- Subscriptions ----------

    function isPackageHandle(handle) {
        return getPackageHandles().has(handle);
    }

    function subscriptionInfo(handle, regularPriceRaw) {
        // Returnerer abonnement-info KUN for almindelige produkter (20% off).
        // Pakker har allerede bundle-rabat indbygget i .price — vi laver ikke en
        // dobbelt-rabat-beregning. Pakke-besparelse vises i stedet vs. compareAtPrice.
        if (isPackageHandle(handle)) return null;
        const num = parseFloat(regularPriceRaw);
        if (isNaN(num) || num <= 0) return null;
        const discountPct = 20;
        const subscriptionPrice = num * (1 - discountPct / 100);
        return {
            discountPct,
            subscriptionPrice: subscriptionPrice.toFixed(2),
            regularPrice: num.toFixed(2),
        };
    }

    function packagePricingInfo(price, compareAtPrice) {
        // For pakker er Shopify.price ALLEREDE abonnementsprisen (bundle-prisen).
        // Vi skal IKKE multiplicere med 0,7 — det ville give dobbelt-rabat.
        // - Abonnementspris (vist stort): direkte fra .price
        // - Normalpris (vist overstreget): compare_at_price (hvis sat)
        const p = parseFloat(price);
        if (isNaN(p) || p <= 0) return null;
        const c = parseFloat(compareAtPrice);
        const hasCompare = !isNaN(c) && c > p;
        // Beregn faktisk rabat-procent ud fra compare → bundle pris
        const discountPct = hasCompare ? Math.round(((c - p) / c) * 100) : 30;
        return {
            subscriptionPrice: p.toFixed(2),
            normalPrice: hasCompare ? c.toFixed(2) : "",
            discountPct,
        };
    }

    // ---------- Question flattening ----------

    function rebuildFlattenedQuestions() {
        const flat = [];
        for (const cId of state.selectedCollections) {
            const c = getCollection(cId);
            if (!c) continue;
            c.questions.forEach((q, idx) => {
                flat.push({
                    collectionId: c.id,
                    question: q,
                    qNumber: idx + 1,
                    totalForCollection: c.questions.length,
                });
            });
        }
        state.flattenedQuestions = flat;
    }

    // ---------- Scoring ----------

    function scoreForCollection(collectionId) {
        const c = getCollection(collectionId);
        if (!c) return { score: 0, max: 0 };
        let score = 0;
        let max = 0;
        for (const q of c.questions) {
            max += 2; // højest mulige point pr. spørgsmål
            const ans = state.answers[`${collectionId}:${q.id}`];
            const opt = getAnswerOption(ans);
            if (opt) score += opt.points;
        }
        return { score, max };
    }

    // ---------- Recommendations ----------

    function recommendationsForCollection(collectionId) {
        const c = getCollection(collectionId);
        if (!c) return { groups: [], threshold: null, score: 0 };
        const { score } = scoreForCollection(collectionId);
        const threshold = getThresholdFor(score);

        const groups = [];
        const level = threshold.level;

        // Niveau "package" og "full" SKAL IKKE vise basisprodukter (per kunde-instruks
        // master-version 2). De vises kun ved "basic" og "main" niveau.
        const showBasics = level === "basic" || level === "main";
        // Pakke vises ved niveau "package" og "full"
        const showPackage = (level === "package" || level === "full") && c.package;
        // Hovedprodukter vises fra niveau "main" og opefter
        const showMain = (level === "main" || level === "package" || level === "full")
            && c.mainProducts && c.mainProducts.length;
        // Sekundære/relaterede vises kun ved "full"
        const showSecondary = level === "full" && c.secondaryProducts && c.secondaryProducts.length;

        if (showPackage) {
            groups.push({
                key: "package",
                label: t("product_group_package"),
                handles: [c.package],
            });
        }
        if (showMain) {
            groups.push({
                key: "main",
                label: c.mainProducts.length > 1
                    ? t("product_group_main_multi")
                    : t("product_group_main_single"),
                handles: c.mainProducts,
            });
        }
        if (showSecondary) {
            groups.push({
                key: "secondary",
                label: t("product_group_secondary"),
                handles: c.secondaryProducts,
            });
        }
        if (showBasics && c.basicProducts && c.basicProducts.length) {
            groups.push({
                key: "basic",
                label: t("product_group_basic"),
                handles: c.basicProducts,
            });
        }

        return { groups, threshold, score };
    }

    // ---------- Live product fetching (Shopify mode) ----------

    function normalizeImageUrl(url) {
        if (!url) return "";
        // Shopify returnerer protocol-relative URLs ("//cdn.shopify.com/...").
        // Det fejler når demoen åbnes fra file:// — prefix med https:
        if (url.startsWith("//")) return "https:" + url;
        return url;
    }

    async function fetchLiveProduct(handle) {
        try {
            const res = await fetch(`${SHOP_URL}/products/${handle}.js`);
            if (!res.ok) throw new Error(res.status);
            const data = await res.json();
            return {
                handle,
                title: data.title,
                shortTitle: data.title.split("|").pop().trim(),
                price: (data.price / 100).toFixed(2),
                compareAtPrice:
                    data.compare_at_price != null
                        ? (data.compare_at_price / 100).toFixed(2)
                        : "",
                image: normalizeImageUrl(data.featured_image),
                url: `${SHOP_URL}/products/${handle}`,
            };
        } catch (e) {
            console.warn(`[Sandvig quiz] Kunne ikke hente live produkt: ${handle}`, e);
            return null;
        }
    }

    async function hydrateProducts(handles) {
        if (!FETCH_LIVE_PRODUCTS) return false;
        const toFetch = handles.filter((h) => {
            const p = CONFIG.products[h];
            return !p || !p._hydrated;
        });
        if (toFetch.length === 0) return false;
        let anyChange = false;
        await Promise.all(
            toFetch.map(async (h) => {
                const live = await fetchLiveProduct(h);
                // Markér som hydreret uanset om vi fik live data — undgår uendelig fetch-loop
                CONFIG.products[h] = {
                    ...(CONFIG.products[h] || { handle: h }),
                    ...(live || {}),
                    _hydrated: true,
                };
                if (live) anyChange = true;
            })
        );
        return anyChange;
    }

    // ---------- Klaviyo signup ----------

    function fireAnonymousViewedResult() {
        // Fyrer "Viewed Sundhedstest Result" anonymt via Klaviyos Onsite Tracker
        // (window._learnq) som Klaviyo Shopify-appen loader på alle sider.
        // Kræver IKKE email — tracker alle der gennemfører quizzen.
        // Fyres kun én gang pr session for at undgå duplicate events ved re-render.
        if (state._viewedResultTracked) return;
        if (typeof window === "undefined") return;
        try {
            const _learnq = window._learnq;
            if (!_learnq || typeof _learnq.push !== "function") {
                // _learnq er ikke tilgængeligt — fx i standalone-demoen eller
                // hvis Klaviyo Shopify-appen ikke er installeret.
                return;
            }
            const behovListe = state.selectedCollections
                .map((cid) => getCollection(cid)?.title)
                .filter(Boolean)
                .join(", ");
            const summary = state.selectedCollections
                .map((cid) => {
                    const c = getCollection(cid);
                    const { score } = scoreForCollection(cid);
                    const th = getThresholdFor(score);
                    return `${c.title}: ${score} (${th.label})`;
                })
                .join(" | ");
            _learnq.push([
                "track",
                "Viewed Sundhedstest Result",
                {
                    sundhedstest_behov: behovListe,
                    sundhedstest_resultat: summary,
                    sundhedstest_antal_behov: state.selectedCollections.length,
                    sundhedstest_dato: new Date().toISOString(),
                },
            ]);
            state._viewedResultTracked = true;
        } catch (e) {
            console.warn("[Sandvig quiz] _learnq tracking fejl:", e);
        }
    }

    async function fireKlaviyoMetricEvent(email, resultData) {
        // Fire "Completed Sundhedstest" som Klaviyo Metric event.
        // Dette triggers uafhængigt af list-membership, så eksisterende
        // Newsletter-subscribers også får deres opfølgnings-mail.
        if (!KLAVIYO_COMPANY_ID) return { ok: false, skipped: true };
        const nowIso = new Date().toISOString();
        try {
            const eventBody = {
                data: {
                    type: "event",
                    attributes: {
                        properties: {
                            sundhedstest_resultat: resultData.summary,
                            sundhedstest_url: resultData.url,
                            sundhedstest_behov: resultData.behov,
                            sundhedstest_dato: nowIso,
                        },
                        time: nowIso,
                        metric: {
                            data: {
                                type: "metric",
                                attributes: { name: "Completed Sundhedstest" },
                            },
                        },
                        profile: {
                            data: {
                                type: "profile",
                                attributes: {
                                    email,
                                    properties: {
                                        sundhedstest_resultat: resultData.summary,
                                        sundhedstest_url: resultData.url,
                                        sundhedstest_behov: resultData.behov,
                                        sundhedstest_dato: nowIso,
                                    },
                                },
                            },
                        },
                    },
                },
            };
            const res = await fetch(
                `https://a.klaviyo.com/client/events/?company_id=${KLAVIYO_COMPANY_ID}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        revision: "2024-07-15",
                    },
                    body: JSON.stringify(eventBody),
                }
            );
            return { ok: res.ok };
        } catch (e) {
            console.warn("[Sandvig quiz] Klaviyo event-fejl:", e);
            return { ok: false };
        }
    }

    async function submitToKlaviyo(email, resultData) {
        if (!KLAVIYO_COMPANY_ID) {
            console.warn("[Sandvig quiz] Klaviyo ikke konfigureret — springer signup over");
            return { ok: true, mock: true };
        }
        try {
            // Klaviyo Subscribe API (Client-side)
            const body = {
                data: {
                    type: "subscription",
                    attributes: {
                        custom_source: "Sundhedstest",
                        profile: {
                            data: {
                                type: "profile",
                                attributes: {
                                    email,
                                    properties: {
                                        sundhedstest_resultat: resultData.summary,
                                        sundhedstest_url: resultData.url,
                                        sundhedstest_behov: resultData.behov,
                                        sundhedstest_dato: new Date().toISOString(),
                                    },
                                },
                            },
                        },
                    },
                    relationships: KLAVIYO_LIST_ID
                        ? { list: { data: { type: "list", id: KLAVIYO_LIST_ID } } }
                        : {},
                },
            };
            const res = await fetch(
                `https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_COMPANY_ID}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        revision: "2024-07-15",
                    },
                    body: JSON.stringify(body),
                }
            );
            return { ok: res.ok };
        } catch (e) {
            console.error("[Sandvig quiz] Klaviyo fejl:", e);
            return { ok: false };
        }
    }

    // ---------- Render ----------

    function render() {
        const screens = {
            welcome: renderWelcome,
            picker: renderPicker,
            questions: renderQuestions,
            result: renderResult,
        };
        const fn = screens[state.step] || renderWelcome;
        try {
            ROOT.innerHTML = `<div class="sp-quiz">${fn()}</div>`;
            bindEvents();
        } catch (err) {
            console.error("[Sandvig quiz] Render-fejl:", err);
            ROOT.innerHTML = `<div class="sp-quiz">
                <div style="text-align:center;padding:60px 20px">
                    <h2>Beklager, der opstod en fejl</h2>
                    <p style="color:var(--sp-text-muted)">Prøv at genindlæse siden eller starte testen forfra.</p>
                    <button class="sp-btn sp-btn--primary button button--xl" onclick="window.location.search=''">Genindlæs</button>
                </div>
            </div>`;
            return;
        }
        // Scroll til top ved skift af step (skipper i miljøer uden scrollIntoView)
        if (typeof ROOT.scrollIntoView === "function") {
            try { ROOT.scrollIntoView({ behavior: "smooth", block: "start" }); } catch (_) {}
        }
    }

    function renderWelcome() {
        return `
            <div class="sp-screen sp-welcome">
                <div class="sp-welcome__eyebrow">${html(t("welcome_eyebrow"))}</div>
                <h1>${html(t("welcome_heading"))}</h1>
                <p class="sp-welcome__intro">${html(t("welcome_intro"))}</p>
                <button class="sp-btn sp-btn--primary button button--xl" data-action="start">
                    ${html(t("welcome_start_button"))}
                </button>
                <div class="sp-disclaimer" style="max-width:640px;margin:40px auto 0;text-align:left">
                    ${html(CONFIG.standardDisclaimer)}
                </div>
            </div>
        `;
    }

    function renderPicker() {
        const selectedCount = state.selectedCollections.length;
        const cards = CONFIG.collections
            .map((c) => {
                const selected = state.selectedCollections.includes(c.id);
                const disabled = !selected && selectedCount >= MAX_SELECTIONS;
                return `
                <button class="sp-card ${selected ? "sp-card--selected" : ""}"
                        data-action="toggle-collection"
                        data-collection-id="${c.id}"
                        ${disabled ? "disabled" : ""}>
                    <div class="sp-card__title">${escapeHtml(c.title)}</div>
                </button>
            `;
            })
            .join("");

        return `
            <div class="sp-screen">
                <div class="sp-picker__header">
                    <h2>${escapeHtml(t("picker_heading"))}</h2>
                    <p class="sp-picker__hint">${escapeHtml(t("picker_hint", { max: MAX_SELECTIONS }))}</p>
                    <div class="sp-picker__counter ${selectedCount === MAX_SELECTIONS ? "sp-picker__counter--full" : ""}">
                        ${escapeHtml(t("picker_counter", { count: selectedCount, max: MAX_SELECTIONS }))}
                    </div>
                </div>
                <div class="sp-picker__grid">${cards}</div>
                <div class="sp-picker__actions">
                    <button class="sp-btn sp-btn--ghost button button--subdued button--sm" data-action="back-to-welcome">
                        ${escapeHtml(t("picker_back_button"))}
                    </button>
                    <button class="sp-btn sp-btn--primary button button--xl"
                            data-action="start-questions"
                            ${selectedCount === 0 ? "disabled" : ""}>
                        ${escapeHtml(t("picker_continue_button"))}
                    </button>
                </div>
            </div>
        `;
    }

    function renderQuestions() {
        const total = state.flattenedQuestions.length;
        const idx = state.currentQuestionIdx;
        const current = state.flattenedQuestions[idx];
        if (!current) {
            // Færdig
            state.step = "result";
            return renderResult();
        }
        const collection = getCollection(current.collectionId);
        const currentAnswer = state.answers[`${current.collectionId}:${current.question.id}`];
        const progressPct = ((idx) / total) * 100;

        const answerButtons = CONFIG.answerOptions
            .map(
                (opt) => `
            <button class="sp-answer ${currentAnswer === opt.value ? "sp-answer--selected" : ""}"
                    data-action="answer"
                    data-value="${opt.value}">
                <span class="sp-answer__radio"></span>
                ${escapeHtml(opt.label)}
            </button>
        `
            )
            .join("");

        const isFirstQuestion = idx === 0;
        const prevAction = isFirstQuestion ? "back-to-picker" : "prev-question";
        const prevLabel = isFirstQuestion
            ? t("q_back_to_picker")
            : t("q_prev_button");
        const hasAnswer = !!currentAnswer;
        const nextLabel = idx === total - 1 ? t("q_last_button") : t("q_next_button");

        return `
            <div class="sp-screen sp-question">
                <div class="sp-progress">
                    <div class="sp-progress__bar">
                        <div class="sp-progress__fill" style="width:${progressPct}%"></div>
                    </div>
                    <div class="sp-progress__meta">
                        <span class="sp-progress__collection">${escapeHtml(collection.title)}</span>
                        <span>${idx + 1} / ${total}</span>
                    </div>
                </div>
                <div class="sp-question__text">${escapeHtml(current.question.text)}</div>
                <div class="sp-answers">${answerButtons}</div>
                <div class="sp-question__nav">
                    <button class="sp-btn sp-btn--ghost button button--subdued button--sm" data-action="${prevAction}">
                        ${escapeHtml(prevLabel)}
                    </button>
                    ${hasAnswer ? `
                    <button class="sp-btn sp-btn--secondary button button--lg button--outline" data-action="next-question">
                        ${escapeHtml(nextLabel)}
                    </button>` : `
                    <div style="font-size:13px;color:var(--sp-text-muted);text-align:right">
                        Q${current.qNumber}/${current.totalForCollection} · ${escapeHtml(collection.title)}
                    </div>`}
                </div>
            </div>
        `;
    }

    function renderProductCard(handle, ctx) {
        ctx = ctx || {};
        const p = getProduct(handle);
        if (!p) {
            return `<div class="sp-product"><div class="sp-product__name">${boldProductName(handle.toUpperCase())}</div></div>`;
        }
        const baseUrl = p.url || `${SHOP_URL}/products/${handle}`;
        const url = withUtm(baseUrl, {
            campaign: ctx.campaign || "",
            content: handle,
            term: "productlink",
        });
        const imageUrl = normalizeImageUrl(p.image);
        const img = imageUrl
            ? `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(p.alt || p.title)}" loading="lazy">`
            : `<div class="sp-product__image--placeholder">${escapeHtml(handle.toUpperCase().slice(0, 3))}</div>`;
        const isPackage = isPackageHandle(handle);
        const subDescription = (p.title || "").split("|")[0].trim().slice(0, 80);

        let badge = "";
        let pricing = "";

        if (isPackage) {
            // Pakker: kun abonnementspris (engangskøb ikke tilgængelig per kunde).
            // Vises som "Abonnement: X" + evt. overstreget compareAtPrice som normalpris.
            const pkg = packagePricingInfo(p.price, p.compareAtPrice);
            if (pkg) {
                badge = `<span class="sp-product__badge">-${pkg.discountPct}%</span>`;
                const normalLine = pkg.normalPrice
                    ? `<div class="sp-product__price sp-product__price--once">
                           Normalt: <s>${formatPrice(pkg.normalPrice)}</s>
                       </div>`
                    : "";
                pricing = `
                    <div class="sp-product__pricing">
                        <div class="sp-product__price sp-product__price--sub">
                            Abonnement: <strong>${formatPrice(pkg.subscriptionPrice)}</strong>
                        </div>
                        ${normalLine}
                    </div>`;
            } else {
                pricing = `
                    <div class="sp-product__pricing">
                        <div class="sp-product__price"><strong>${formatPrice(p.price)}</strong></div>
                    </div>`;
            }
        } else {
            // Almindelige produkter: engangskøb + abonnement (-20%)
            const sub = subscriptionInfo(handle, p.price);
            if (sub) {
                badge = `<span class="sp-product__badge">-${sub.discountPct}%</span>`;
                pricing = `
                    <div class="sp-product__pricing">
                        <div class="sp-product__price sp-product__price--sub">
                            Abonnement: <strong>${formatPrice(sub.subscriptionPrice)}</strong>
                        </div>
                        <div class="sp-product__price sp-product__price--once">
                            Engangskøb: ${formatPrice(p.price)}
                        </div>
                    </div>`;
            } else {
                pricing = `
                    <div class="sp-product__pricing">
                        <div class="sp-product__price">${formatPrice(p.price)}</div>
                    </div>`;
            }
        }

        return `
            <a class="sp-product" href="${escapeHtml(url)}" target="_top">
                ${badge}
                <div class="sp-product__image">${img}</div>
                <div class="sp-product__name">${boldProductName(p.shortTitle || p.title || handle)}</div>
                <div class="sp-product__sub">${escapeHtml(subDescription)}</div>
                ${pricing}
            </a>
        `;
    }

    function renderResultSection(collectionId) {
        const c = getCollection(collectionId);
        if (!c) return "";
        const { groups, threshold, score } = recommendationsForCollection(collectionId);
        const tKey = thresholdKey(threshold);
        const body = c.resultBodies[tKey] || c.resultBodies["0-3"] || "";

        const ctx = { campaign: c.slug };
        const groupsHtml = groups
            .map(
                (g) => `
            <div class="sp-product-group">
                <div class="sp-product-group__label">${escapeHtml(g.label)}</div>
                <div class="sp-products">
                    ${g.handles.map((h) => renderProductCard(h, ctx)).join("")}
                </div>
            </div>
        `
            )
            .join("");

        const cta = c.cta;
        let ctaHtml = "";
        if (cta && cta.primaryHandle) {
            const baseUrl = `${SHOP_URL}/products/${cta.primaryHandle}`;
            const primaryUrl = withUtm(baseUrl, {
                campaign: c.slug,
                content: cta.primaryHandle,
                term: "productlink",
            });
            ctaHtml = `
                <div class="sp-cta-row">
                    <a class="sp-btn sp-btn--primary button button--xl" href="${escapeHtml(primaryUrl)}" target="_top">
                        ${cta.primaryText
                            ? html(cta.primaryText)
                            : `Se ${boldProductName(cta.primaryHandle.toUpperCase())}`}
                    </a>
                </div>
            `;
        }

        return `
            <section class="sp-result-section">
                <header class="sp-result-section__head">
                    <h3 class="sp-result-section__title">${escapeHtml(c.title)}</h3>
                    <div class="sp-score">
                        <span>${escapeHtml(t("score_label_prefix"))}</span>
                        <span class="sp-score__value">${score}</span>
                        <span>${escapeHtml(t("score_label_of", { max: c.questions.length * 2 }))}</span>
                        <span class="sp-score__level" style="background:${threshold.color}25;color:${threshold.color}">
                            ${escapeHtml(threshold.label)}
                        </span>
                    </div>
                </header>
                <div class="sp-result-section__body">${html(body)}</div>
                ${groupsHtml}
                ${ctaHtml}
            </section>
        `;
    }

    function renderResult() {
        // Opdatér URL med komprimeret state — så brugeren kan kopiere/dele linket
        // og Klaviyo-mailen kan deep-linke direkte tilbage.
        updateUrlState();

        // Anonym completion-tracking — fyrer én gang pr session når resultatsiden
        // vises, uafhængigt af om brugeren submitter email.
        fireAnonymousViewedResult();

        const sections = state.selectedCollections.map(renderResultSection).join("");
        const allHandles = state.selectedCollections.flatMap((cid) => {
            const r = recommendationsForCollection(cid);
            return r.groups.flatMap((g) => g.handles);
        });

        // Pre-fetch live produktdata hvis aktiveret. Re-render KUN hvis noget
        // faktisk blev opdateret OG vi stadig er på resultatsiden.
        if (FETCH_LIVE_PRODUCTS && !state._hydrationStarted) {
            state._hydrationStarted = true;
            hydrateProducts([...new Set(allHandles)])
                .then((changed) => {
                    if (changed && state.step === "result") render();
                })
                .catch((err) => console.warn("[Sandvig quiz] hydrate fejl:", err));
        }

        const allProductsUrl = withUtm(
            `${SHOP_URL}/collections/sundhedspakker-og-produkter`,
            { campaign: "footer", content: "all_products" }
        );

        const summaryKey = state.selectedCollections.length === 1
            ? "result_summary_single"
            : "result_summary_multi";
        return `
            <div class="sp-screen">
                <div class="sp-result__header">
                    <div class="sp-result__eyebrow">${escapeHtml(t("result_eyebrow"))}</div>
                    <h2>${escapeHtml(t("result_heading"))}</h2>
                    <p class="sp-result__summary">${escapeHtml(t(summaryKey))}</p>
                </div>
                ${sections}
                ${renderEmailCapture()}
                <div class="sp-disclaimer">${html(CONFIG.standardDisclaimer)}</div>
                <div class="sp-footer-actions">
                    <button class="sp-btn sp-btn--secondary button button--lg button--outline" data-action="restart">
                        ${escapeHtml(t("result_restart_button"))}
                    </button>
                    <a class="sp-btn sp-btn--primary button button--lg" href="${escapeHtml(allProductsUrl)}" target="_top">
                        ${escapeHtml(t("result_all_products_link"))}
                    </a>
                </div>
            </div>
        `;
    }

    function renderEmailCapture() {
        return `
            <div class="sp-email-capture" id="sp-email-capture">
                <h3>${escapeHtml(t("email_heading"))}</h3>
                <p>${escapeHtml(t("email_subtitle"))}</p>
                <form class="sp-email-form" data-action="email-submit">
                    <input type="email" name="email" required placeholder="${escapeHtml(t("email_placeholder"))}" autocomplete="email">
                    <button type="submit" class="sp-btn sp-btn--primary button button--xl">${escapeHtml(t("email_submit_button"))}</button>
                </form>
                <p class="sp-email-consent">${escapeHtml(t("email_consent_notice"))}</p>
            </div>
        `;
    }

    // ---------- Events ----------

    function bindEvents() {
        ROOT.querySelectorAll("[data-action]").forEach((el) => {
            const action = el.dataset.action;
            const handler = handlers[action];
            if (!handler) return;
            const eventName = el.tagName === "FORM" ? "submit" : "click";
            el.addEventListener(eventName, (e) => handler(e, el));
        });
    }

    const handlers = {
        start: () => {
            state.step = "picker";
            render();
        },
        "back-to-welcome": () => {
            state.step = "welcome";
            render();
        },
        "toggle-collection": (e, el) => {
            const id = parseInt(el.dataset.collectionId, 10);
            const ix = state.selectedCollections.indexOf(id);
            if (ix >= 0) state.selectedCollections.splice(ix, 1);
            else if (state.selectedCollections.length < MAX_SELECTIONS)
                state.selectedCollections.push(id);
            render();
        },
        "start-questions": () => {
            if (state.selectedCollections.length === 0) return;
            rebuildFlattenedQuestions();
            state.currentQuestionIdx = 0;
            state.step = "questions";
            render();
        },
        answer: (e, el) => {
            const current = state.flattenedQuestions[state.currentQuestionIdx];
            if (!current) return;
            const key = `${current.collectionId}:${current.question.id}`;
            const hadPriorAnswer = state.answers[key] !== undefined;
            state.answers[key] = el.dataset.value;

            // Toggle valgt-tilstand direkte i DOM — ingen full re-render,
            // ingen dobbelt fade-animation.
            el.parentNode.querySelectorAll(".sp-answer").forEach((b) =>
                b.classList.toggle("sp-answer--selected", b === el)
            );

            if (!hadPriorAnswer) {
                // Auto-advance kun ved første besvarelse af et spørgsmål
                setTimeout(() => {
                    if (state.currentQuestionIdx < state.flattenedQuestions.length - 1) {
                        state.currentQuestionIdx++;
                    } else {
                        state.step = "result";
                    }
                    render();
                }, 280);
            }
            // Ved ændring af eksisterende svar — bare opdater valgt-tilstand,
            // lad brugeren selv klikke "Næste" (knappen er allerede synlig).
        },
        "prev-question": () => {
            if (state.currentQuestionIdx > 0) {
                state.currentQuestionIdx--;
                render();
            }
        },
        "next-question": () => {
            if (state.currentQuestionIdx < state.flattenedQuestions.length - 1) {
                state.currentQuestionIdx++;
                render();
            } else {
                state.step = "result";
                render();
            }
        },
        "back-to-picker": () => {
            // Tilbage til behovsvælger uden at miste valg eller svar.
            state.step = "picker";
            render();
        },
        restart: () => {
            state.step = "welcome";
            state.selectedCollections = [];
            state.currentQuestionIdx = 0;
            state.answers = {};
            state.flattenedQuestions = [];
            state._hydrationStarted = false;
            state._viewedResultTracked = false;
            // Ryd ?r= fra URL'en så genstart starter forfra
            if (typeof window !== "undefined" && window.history?.replaceState) {
                try {
                    const u = new URL(window.location.href);
                    u.searchParams.delete("r");
                    window.history.replaceState({}, "", u.toString());
                } catch (_) {}
            }
            render();
        },
        "email-submit": async (e, el) => {
            e.preventDefault();
            const email = el.querySelector('input[name="email"]').value.trim();
            if (!email) return;
            // Byg resultatdata til Klaviyo
            const summary = state.selectedCollections
                .map((cid) => {
                    const c = getCollection(cid);
                    const { score } = scoreForCollection(cid);
                    const t = getThresholdFor(score);
                    return `${c.title}: ${score} (${t.label})`;
                })
                .join(" | ");
            const behovListe = state.selectedCollections
                .map((cid) => getCollection(cid)?.title)
                .filter(Boolean)
                .join(", ");
            const url = withUtm(fullResultUrl(), {
                campaign: "klaviyo_followup",
                content: "resultat_link",
            });
            const btn = el.querySelector("button");
            const original = btn.textContent;
            btn.textContent = t("email_submit_sending");
            btn.disabled = true;
            const payload = { summary, url, behov: behovListe };
            // Kør begge parallelt: Subscribe (list-add + properties) og Metric event
            // (triggerer flow uafhængigt af list-status).
            const [result] = await Promise.all([
                submitToKlaviyo(email, payload),
                fireKlaviyoMetricEvent(email, payload),
            ]);
            const wrap = document.getElementById("sp-email-capture");
            if (result.ok) {
                wrap.innerHTML = `
                    <h3>${escapeHtml(t("email_success_heading"))}</h3>
                    <p class="sp-email-success">
                        ${escapeHtml(t("email_success_message", { email }))}${result.mock ? " <em>(demo)</em>" : ""}
                    </p>
                `;
            } else {
                btn.textContent = original;
                btn.disabled = false;
                alert("Der opstod en fejl. Prøv venligst igen.");
            }
        },
    };

    // ---------- Boot ----------

    function showLoading() {
        ROOT.innerHTML = `
            <div class="sp-quiz">
                <div style="text-align:center;padding:80px 20px;color:var(--sp-text-muted)">
                    <div style="display:inline-block;width:32px;height:32px;border:3px solid var(--sp-border);border-top-color:var(--sp-green-900);border-radius:50%;animation:spSpin 0.8s linear infinite;margin-bottom:16px"></div>
                    <div>Indlæser sundhedstest…</div>
                </div>
                <style>@keyframes spSpin{to{transform:rotate(360deg)}}</style>
            </div>
        `;
    }

    function restoreStateFromUrl() {
        if (typeof window === "undefined") return false;
        try {
            const params = new URLSearchParams(window.location.search);
            const encoded = params.get("r");
            if (!encoded) return false;
            const decoded = decodeStateFromUrl(encoded);
            if (!decoded || !decoded.collectionIds.length) return false;
            state.selectedCollections = decoded.collectionIds;
            state.answers = decoded.answers;
            rebuildFlattenedQuestions();
            state.step = "result";
            return true;
        } catch (e) {
            console.warn("[Sandvig quiz] Kunne ikke genskabe state fra URL:", e);
            return false;
        }
    }

    async function boot() {
        if (!CONFIG) {
            showLoading();
            const loaded = await loadConfig();
            if (!loaded) {
                ROOT.innerHTML = `<div class="sp-quiz"><p style="text-align:center;padding:40px;color:var(--sp-error)">Kunne ikke indlæse sundhedstesten. Prøv venligst igen senere.</p></div>`;
                return;
            }
        }
        // Hvis URL'en indeholder ?r=... — spring direkte til resultatside
        restoreStateFromUrl();
        render();
    }

    boot();
})();
